import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plus, Trash2, ListMusic, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { mediaApi } from "../api";

export default function MediaPlaylists() {
  const [playlists, setPlaylists] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [allItems, setAllItems] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const [pls, content] = await Promise.all([mediaApi.playlists(), mediaApi.contentAll()]);
      setPlaylists(pls);
      setAllItems(content);
    } catch {}
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const byId = Object.fromEntries(allItems.map((i) => [i.ID_ConteudoMediaCenter, i]));

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await mediaApi.playlistCreate(name.trim());
    setName("");
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Apagar playlist?")) return;
    await mediaApi.playlistDelete(id);
    load();
  };

  const removeItem = async (pid, iid) => {
    await mediaApi.playlistRemoveItem(pid, iid);
    load();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="px-4 md:px-8 lg:px-12 py-12 max-w-[1200px] mx-auto"
      data-testid="media-playlists-page"
    >
      <div className="flex items-center gap-3 mb-10">
        <ListMusic className="text-[#D1CFC9]" />
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#D1CFC9] font-bold mb-1">A tua música</p>
          <h1 className="font-serif text-5xl font-light">Playlists</h1>
        </div>
      </div>

      <form onSubmit={create} className="flex gap-2 mb-10" data-testid="media-playlist-create-form">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nome da nova playlist..."
          className="flex-1"
          data-testid="media-playlist-name-input"
        />
        <button type="submit" className="media-btn-primary inline-flex items-center gap-2" data-testid="media-playlist-create-submit">
          <Plus size={16} /> Criar
        </button>
      </form>

      {loading ? (
        <div className="live-dot mx-auto" />
      ) : playlists.length === 0 ? (
        <div className="text-center py-20 text-slate-400" data-testid="media-playlists-empty">
          Ainda não criaste nenhuma playlist.
        </div>
      ) : (
        <div className="space-y-6">
          {playlists.map((p) => (
            <div key={p.id} className="media-card rounded-2xl p-6" data-testid={`media-playlist-${p.id}`}>
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h3 className="font-serif text-2xl font-medium">{p.name}</h3>
                  <p className="text-xs text-slate-400">{p.count} item{p.count !== 1 ? "s" : ""}</p>
                </div>
                <button onClick={() => del(p.id)} className="text-slate-500 hover:text-red-400" data-testid={`media-playlist-delete-${p.id}`}>
                  <Trash2 size={18} />
                </button>
              </div>
              <div className="space-y-1">
                {p.items.length === 0 && <p className="text-sm text-slate-500">Playlist vazia.</p>}
                {p.items.map((iid) => {
                  const it = byId[iid];
                  if (!it) return null;
                  return (
                    <div key={iid} className="flex items-center gap-3 py-2 px-3 rounded-lg hover:bg-white/5 group">
                      <Link to={`/media/watch/${iid}`} className="flex-1 flex items-center gap-3">
                        <div className="w-10 h-10 rounded bg-[#D1CFC9]/20 grid place-items-center text-[#E8E6E2] text-sm font-serif">
                          {it.IsAudio ? "♪" : "▶"}
                        </div>
                        <span className="text-sm flex-1 truncate">{it.Descricao}</span>
                        <ChevronRight size={14} className="text-slate-500 opacity-0 group-hover:opacity-100" />
                      </Link>
                      <button onClick={() => removeItem(p.id, iid)} className="text-slate-600 hover:text-red-400 opacity-0 group-hover:opacity-100">
                        <Trash2 size={14} />
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </motion.div>
  );
}
